import React from "react";
import I18n from "../../../i18n/";
import { CounselingGeneric } from "./index";
import ReportAction from "../../../actions/ReportAction";
import { TargetValueType } from "../CompareValuePanel";
import { CounselingSupportGraph } from "../../../constants/supportGraph";

export default (props)=>(
	<CounselingGeneric 
		typeKey={CounselingSupportGraph.ProviderType}
		subHeader={I18n.t("provider")}
		fetchMain={ReportAction.fetchCounProvider}
	/>
);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/CounselingProvider.js